"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get parseSortSchema () {
        return parseSortSchema;
    },
    get sortStringSchema () {
        return sortStringSchema;
    },
    get transformStringToArray () {
        return transformStringToArray;
    },
    get transformStringToBoolean () {
        return transformStringToBoolean;
    }
});
const _zod = require("zod");
/**
 * sortFieldSchema is a zod schema that validates a non-empty sort field name.
 */ const sortFieldSchema = _zod.z.string().refine((field)=>field.length > 0, {
    message: "Field name cannot be empty."
});
const parseSortSchema = (sortString)=>{
    if (typeof sortString !== "string") {
        return false;
    }
    const [order, field] = sortString.split("(");
    const sortOrder = order.toLowerCase() === "asc" ? 1 : -1;
    if (!field || field.slice(-1) !== ")") {
        return false;
    }
    const fieldName = field.slice(0, -1);
    if (!sortFieldSchema.safeParse(fieldName).success) {
        return false;
    }
    return {
        field: fieldName,
        sortOrder
    };
};
const sortStringSchema = _zod.z.string().refine((sortString)=>sortString.length > 0, {
    message: "Sort string cannot be empty."
}).optional().transform((sortString)=>{
    if (!sortString) {
        return undefined;
    }
    const sortMap = {};
    sortString.split(",").map((sortClause)=>{
        const parsedSortClause = parseSortSchema(sortClause);
        if (!parsedSortClause) {
            return undefined;
        }
        sortMap[parsedSortClause.field] = parsedSortClause.sortOrder;
    });
    return sortMap;
});
const transformStringToArray = (elementSchema)=>{
    return _zod.z.union([
        _zod.z.array(elementSchema),
        elementSchema
    ]).transform((data)=>{
        if (!Array.isArray(data)) {
            return [
                data
            ];
        }
        return data;
    });
};
const transformStringToBoolean = _zod.z.preprocess((val)=>{
    if (typeof val === "string") {
        const lowerVal = val.toLowerCase();
        if (lowerVal === "true") return true;
        if (lowerVal === "false") return false;
    }
    return val;
}, _zod.z.boolean().optional());
